import {
    UPDATE_USER_DETAIL_REDUCER,
    UPDATE_USER_REDUCER,
} from 'store/actionTypes';
import {
    ActionType,
    UserDetailModal,
    UserListModal,
} from 'utils/modals';

export const UserReducer = (
    state: UserListModal = new UserListModal(),
    action: ActionType,
) => {
    switch (action.type) {
        case UPDATE_USER_REDUCER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
export const UserDetailReducer = (
    state: UserDetailModal = new UserDetailModal(),
    action: ActionType,
) => {
    switch (action.type) {
        case UPDATE_USER_DETAIL_REDUCER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
